<div class="modal-body sticky eula-modal">
  <div class="sticky-header-container">
    <div class="modal-header d-flex flex-row">
      <div class="modal-title" i18n>Terms and Conditions</div>
      <app-close-button (closeClicked)="close(null)" />
    </div>
  </div>
  <div class="body-container">
    <span *ngIf="!isLoading; else loading" class="subtext" [innerHTML]="eulaText$ | async | trustAsHtml"> </span>
  </div>
</div>

<ng-template #loading>
  <div class="d-flex flex-column gap-4">
    <div *appRepeat="4" class="d-flex flex-column">
      <lib-loading-shimmer *appRepeat="4" [height]="'1rem'" [width]="'100%'" />
      <lib-loading-shimmer [height]="'1rem'" [width]="'30%'" />
    </div>
  </div>
</ng-template>
